import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminSettings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [gaId, setGaId] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/settings/public`, { withCredentials: true })
      .then((r) => setGaId(r.data.ga_id || ""))
      .finally(() => setLoading(false));
  }, []);

  const showToast = (text, type = "success") => {
    setToast({ text, type });
    setTimeout(() => setToast(null), 2200);
  };

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(
        `${API}/settings/public`,
        { ga_id: gaId.trim() },
        { withCredentials: true }
      );
      showToast("Settings saved");
    } catch (e) {
      showToast("Save failed", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-shell">
      <div className="admin-topbar">
        <h1>
          <Link to="/admin" style={{ color: "#fff", textDecoration: "none" }}>
            <span className="dot" /> Dosmass CMS
          </Link>
          <span style={{ fontWeight: 400, color: "#a0a0a8", marginLeft: 8, fontSize: 14 }}>
            / settings
          </span>
        </h1>
        <div className="right">
          <span style={{ color: "#a0a0a8", fontSize: 13 }}>{user?.email}</span>
          <button
            className="btn danger"
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="logout-btn"
          >
            Logout
          </button>
        </div>
      </div>

      <div className="admin-content" style={{ maxWidth: 720 }}>
        <Link to="/admin" className="btn secondary" style={{ marginBottom: 24, display: "inline-block" }}>
          ← Back to pages
        </Link>

        <div className="item-row" style={{ marginTop: 0 }}>
          <h2 style={{ marginTop: 0, marginBottom: 6, fontSize: 20 }}>Analytics</h2>
          <p style={{ color: "#a0a0a8", fontSize: 13, marginTop: 0, marginBottom: 20 }}>
            Analytics scripts load only after the visitor consents via the cookie banner.
            PostHog is wired by default. To also run Google Analytics 4, paste your Measurement ID below.
          </p>

          <label style={{ display: "block", fontSize: 11, textTransform: "uppercase", color: "#a0a0a8", marginBottom: 6, letterSpacing: "0.05em" }}>
            Google Analytics 4 Measurement ID
          </label>
          <input
            type="text"
            value={gaId}
            onChange={(e) => setGaId(e.target.value)}
            placeholder="G-XXXXXXXXXX (leave empty to disable GA)"
            disabled={loading}
            data-testid="ga-id-input"
            style={{
              width: "100%", background: "#0f0f10", border: "1px solid #2a2a2e",
              color: "#fafafa", padding: "10px 12px", borderRadius: 6,
              fontFamily: "ui-monospace, monospace", fontSize: 14, boxSizing: "border-box",
            }}
          />
          <p style={{ color: "#6a6a72", fontSize: 12, marginTop: 8 }}>
            Find it in GA4 Admin → Data Streams → your stream. Format: <code>G-XXXXXXXXXX</code>.
          </p>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <button
              className="btn"
              disabled={saving || loading}
              onClick={save}
              data-testid="save-settings"
            >
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </div>
      </div>

      {toast && (
        <div className={`toast ${toast.type}`} data-testid="settings-toast">
          {toast.text}
        </div>
      )}
    </div>
  );
}
